import { PromotionsResponseIType } from '../validators/promotions';

export type TPromotionsResponseIType = ReturnType<
  typeof transformPromotionsResponse
>;

export const transformPromotionsResponse = (
  promotionsResponse: PromotionsResponseIType,
) => {
  const {
    promotions: { bonus },
  } = promotionsResponse;

  return bonus.filter((promo) => promo.bonusCode && promo.title && promo.style);
};
